// Boost glitch effect - brief screen distortion when boost activates

let canvas = null;

/**
 * Triggers a brief glitch effect on the canvas when boost is activated.
 * Uses CSS animation for performance.
 */
export function triggerBoostGlitch() {
  if (!canvas) {
    canvas = document.querySelector('canvas');
  }
  
  if (!canvas) return;
  
  // Remove class first in case animation is still running
  canvas.classList.remove('boost-glitch');
  
  // Force reflow to restart animation
  void canvas.offsetWidth;
  
  // Add glitch class to trigger CSS animation
  canvas.classList.add('boost-glitch');
  
  // Remove class after animation completes (150ms)
  setTimeout(() => {
    canvas.classList.remove('boost-glitch');
  }, 150);
}
